export enum ChromeKeys {
  AccountSettings = 'account-settings',
  AccountRegistration = 'account-registration',
  RetailerAccountRegistration = 'retailer-account-registration',
  AdspAccountRegistration = 'adsp-account-registration',
  IneligibilityRegistration = ' ineligibility-registration',
  DspActivationRequest = 'dsp-activation-request',
  DspActivationActivate = 'dsp-activation-activate',
  DspCreateManagerAccount = 'dsp-create-manager-account',
  ManagerAccountCreation = 'manager-account-creation',
  AccountCombination = 'account-combination',
}

/**
 * Which account a page's chrome represents, mirroring the values the chrome library accepts.
 *
 * Declared here rather than imported because `@amzn/aac-chrome-api` does not re-export its own
 * `PageScope` enum from its entry point, and the string values are the contract either way.
 */
export enum PageScope {
  AllAccounts = 'ALL_ACCOUNTS',
  SingleAccount = 'SINGLE_ACCOUNT',
}

export enum MenuItemIds {
  AccountDetails = 'chrome_side_nav_account_details',
  Users = 'chrome_side_nav_users',
  ManagerAccount = 'chrome_side_nav_manager_accounts',
  SellingAccount = 'chrome_side_nav_selling_account',
  Brands = 'chrome_side_nav_brands',
  ThirdPartyApplication = 'chrome_side_nav_third_party_application',
  DenyList = 'chrome_side_nav_deny_list',
  SponsoredAdsDenyList = 'chrome_side_nav_sponsored_ads_deny_list',
  DataTransparency = 'chrome_side_nav_data_transparency',
}

export enum HeaderTranslationKeys {
  AccessAndSettingsPageName = 'chrome_header_access_and_settings_page_name',
  AccessAndSettingsKey = 'chrome_header_access_and_settings_key',
  DspActivationRequestPageName = 'chrome_header_dsp_activation_request_page_name',
  DspActivationRequestSubmit = 'chrome_header_dsp_activation_request_submit',
  DspActivationActivatePageName = 'chrome_header_dsp_activation_activate_page_name',
  DspActivationActivateSubmit = 'chrome_header_dsp_activation_activate_submit',
  DspCreateManagerAccountPageName = 'chrome_header_dsp_create_manager_account_page_name',
  DspCreateManagerAccountSubmit = 'chrome_header_dsp_create_manager_account_submit',
  ManagerAccountCreationPageName = 'chrome_header_manager_account_creation_page_name',
  Cancel = 'chrome_header_cancel',
}

export enum PageLayoutType {
  Standard = 'STANDARD',
  Focus = 'FOCUS',
  Light = 'LIGHT',
}

export enum ButtonState {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
  Loading = 'LOADING',
}

export enum ButtonType {
  Primary = 'PRIMARY',
  Normal = 'NORMAL',
  Link = 'LINK',
}
